module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "MaterialAlterDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MaterialAlterDetailView!./src/pages/Promote/BusinessHall/AlterMaterial/Detail/DetailView.js
// module id = 1654
// module chunks = 418